var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn",class:{'is-active': _vm.isDirection},on:{"click":function($event){return _vm.scroll()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }